import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

// CREATE ACTION
export const supervisorSalaryAdvanceRequestCreate = createAsyncThunk(
	"supervisorSalaryAdvanceRequestCreate",
	async ({ data }, { rejectWithValue }) => {
		try {
			// data is expected to be an array of requests
			const response = await axiosHttp.post(`requests/supervisor/salary-advance`, data);
			return response.data;
		} catch (err) {
			if (!err.response) {
				throw err;
			}
			return rejectWithValue(err.response.data);
		}
	},
);

const supervisorSalaryAdvanceRequestCreateSlice = createSlice({
	name: "supervisorSalaryAdvanceRequestCreateSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetSupervisorSalaryAdvanceCreateState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(supervisorSalaryAdvanceRequestCreate.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(supervisorSalaryAdvanceRequestCreate.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;

			// Check if all requests failed
			const hasFailed = action.payload?.data?.failed?.length > 0;
			const hasCreated = action.payload?.data?.created?.length > 0;
			const isErrorStatus = action.payload?.status === "error";

			if (isErrorStatus || (hasFailed && !hasCreated)) {
				state.isError = true;
			} else {
				state.isError = false;
			}
		});

		builder.addCase(supervisorSalaryAdvanceRequestCreate.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetSupervisorSalaryAdvanceCreateState } = supervisorSalaryAdvanceRequestCreateSlice.actions;
export default supervisorSalaryAdvanceRequestCreateSlice.reducer;
